// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';

export class IndiceBancoPreco extends BaseResourceModel {
  constructor(
    public id?: number,
    public nome?: string,
    public orgao? : Orgao
  ) {
    super();
  }
  static converteJson(json: any): IndiceBancoPreco {
    return Object.assign(new IndiceBancoPreco(), json);
  }
}
